import { registerAction } from '../../Action'
import { ViewConstants } from '../views/viewConstants'

export const personalPanelAssignmentsRequest =
  'personalPanel/assignments/request'
export const personalPanelAssignmentsSuccess =
  'personalPanel/assignments/success'
export const personalPanelAssignmentsError = 'personalPanel/assignments/error'

const updateNestedState = (state, action, updates) => ({
  ...state,
  entityDataByView: {
    ...state.entityDataByView,
    [ViewConstants.personalPanel]: {
      ...state.entityDataByView[ViewConstants.personalPanel],
      [action.payload.viewKey]: {
        ...state.entityDataByView[ViewConstants.personalPanel][
          action.payload.viewKey
        ],
        ...updates,
      },
    },
  },
})

export const assignmentsFetchRequest = registerAction(
  personalPanelAssignmentsRequest,
  {
    reducer: (state, action) =>
      updateNestedState(state, action, { loadingState: 'loading' }),
  }
)

export const assignmentsFetchSuccess = registerAction(
  personalPanelAssignmentsSuccess,
  {
    reducer: (state, action) =>
      updateNestedState(state, action, { loadingState: 'waiting' }),
  }
)

export const assignmentsFetchError = registerAction(
  personalPanelAssignmentsError,
  {
    reducer: (state, action) =>
      updateNestedState(state, action, {
        loadingState: 'waiting',
        error: action.payload.error,
      }),
  }
)

export default {
  assignmentsFetchRequest,
  assignmentsFetchSuccess,
  assignmentsFetchError,
}
